// extracted by mini-css-extract-plugin
export var assigneeDetails = "_6r-0";
export var assigneeInfo = "_6r-1";
export var editAssigneeInfo = "_6r-2";
export var editAssigneeModalContainer = "_6r-3";